"use client";

import React from "react";
import { Banner } from "@/components/sections/Banner";
import { MultipleEventsLayout } from "@/components/sections/monthly-event/MultipleEventsLayout";
import { SingleEventLayout } from "@/components/sections/monthly-event/SingleEventLayout";
import { SeoSection } from "@/components/sections/SeoSection";
import { EventIntroSection } from "@/(global)/evenements/sections/EventIntroSection";
import { EveningEvents } from "@/(global)/evenements/sections/ThemesEvents";
// import { EventCountdown } from "@/components/sections/EventCountdown";
import Link from "next/link";

import { getCloudinaryUrl } from "@/lib/cloudinary";
import { BreadcrumbHomepage } from "@/components/sections/breadcrumb-homepage/BreadcrumbHomepage";

// Import des événements depuis le fichier statique
import {
  getCurrentEvents,
  formatEventPeriod,
} from "@/(global)/evenements/data/events";

type FormattedEvent = {
  title: string;
  description: string;
  image: string;
  period: string;
  salons: string[];
  promoCode: string;
};

export default function EventsPage() {
  // Récupération et formatage des événements directement
  const currentEvents = getCurrentEvents();
  const events: FormattedEvent[] = currentEvents.map((event) => ({
    title: event.title,
    description: event.description,
    image: event.image,
    period: formatEventPeriod(event.startDate, event.endDate),
    salons: event.salons,
    promoCode: event.promoCode || "",
  }));

  return (
    <>
      <Banner title="Nos Événements" backgroundImage={getCloudinaryUrl("marriage-banner")} />

      <main className="min-h-[50vh]">
        <BreadcrumbHomepage />
        <EventIntroSection />
        {/* <EventCountdown /> */}
        {!events.length ? (
          <div className="flex min-h-[50vh] flex-col items-center justify-center gap-8 bg-primary py-20 text-white">
            <div className="text-center">
              <h2 className="mb-4 font-cormorant text-4xl uppercase ph:text-5xl">
                Aucun événement en cours
              </h2>
              <p className="mb-8 text-lg">
                Il n&apos;y a pas d&apos;événements en ce moment, mais vous
                pouvez toujours réserver votre prochain rendez-vous dans
                l&apos;un de nos salons.
              </p>
              <Link
                href="/reservation"
                className="group relative inline-block overflow-hidden border border-white px-8 py-3"
              >
                <span className="relative z-10 text-white transition-colors group-hover:text-primary">
                  Réserver maintenant
                </span>
                <div className="absolute bottom-0 left-0 h-full w-0 bg-white transition-all duration-300 ease-out group-hover:w-full"></div>
              </Link>
            </div>
          </div>
        ) : (
          <div className="bg-white">
            {events.length === 1 ? (
              <SingleEventLayout event={events[0]} />
            ) : (
              <MultipleEventsLayout events={events} />
            )}
          </div>
        )}
        <EveningEvents />
      </main>

      <SeoSection />
    </>
  );
}
